import clsx from 'clsx'
import type { ComponentProps, ReactNode } from 'react'
import { inputRootStyles as styles } from './input-root.css'

interface Props extends ComponentProps<'label'> {
  label?: ReactNode
  description?: ReactNode
  showOptionalLabel?: boolean

  /** Reserve space below the input for a potential error message. */
  reserveSpaceForError?: boolean
}

export function InputRoot({
  label,
  description,
  showOptionalLabel,
  reserveSpaceForError,
  className,
  children,
  ...props
}: Props) {
  return (
    <label
      {...props}
      className={clsx(styles.container, className)}
      data-reserve-space={reserveSpaceForError}
    >
      {label && (
        <span>
          <span className={styles.title}>{label}</span>
          {showOptionalLabel && (
            <span className={styles.optionalLabel}>(optional)</span>
          )}
        </span>
      )}
      {description && <span className={styles.description}>{description}</span>}

      {children}
    </label>
  )
}
